import { genericNoCorsClient } from '@vfit/shared/data-access';
import { useMutation } from 'react-query';
import { IGenericNoCorsResponse, IGenericNoCorsPayload } from './genericNoCors.models';

const customerEligibilityService = ({ endpoint, params }: IGenericNoCorsPayload) =>
  genericNoCorsClient.post(
    endpoint,
    {
      ...params,
    },
    {
      notJsonParsing: true,
    }
  ) as Promise<IGenericNoCorsResponse>;

export const useGenericNoCors = () =>
  useMutation(['genericNCors'], (data: IGenericNoCorsPayload) => customerEligibilityService(data));
